// extracted by mini-css-extract-plugin
module.exports = {"container":"public_text_image_block_container-module--container--IBoR4"};